<template>
    <div class="cc-consents">
        <div class="cc-consents__header">
            <div class="cc-consents__title">{{ translations['Terms of service _title_'] }}</div>
        </div>
      <terms-of-service/>
      <gift-wrapping/>
      <dm-heureka-consent/>
      <overeno-consent/>
      <newsletter-registration/>
      <shaim-overeno-consent/>
      <recyclable/>
      <dm-glami-consent/>
      <dm-zbozi-consent/>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import TermsOfService from "@/components/_common/TermsOfService/TermsOfService";
    import DmHeurekaConsent from "@/components/_common/modules/dm_heureka/DmHeurekaConsent";
    import OverenoConsent from "@/components/_common/modules/overeno/OverenoConsent";
    import ShaimOverenoConsent from "@/components/_common/modules/shaim_aio/ShaimOverenoConsent";
    import Recyclable from "@/components/_common/Recyclable/Recyclable";
    import GiftWrapping from "@/components/_common/GiftWrapping/GiftWrapping";
    import DmGlamiConsent from "@/components/_common/modules/dm_glami/DmGlamiConsent";
    import DmZboziConsent from "@/components/_common/modules/dm_zbozi/DmZboziConsent";
    import NewsletterRegistration from "../_common/NewsletterRegistration/NewsletterRegistration";

    export default {
      components: {
        NewsletterRegistration,
        DmGlamiConsent,
        DmZboziConsent,
        GiftWrapping,
        Recyclable,
        ShaimOverenoConsent, OverenoConsent, DmHeurekaConsent, TermsOfService},
      computed: {
        ...mapState({
          translations: state => state.translations,
          consents: state => state.consents,
          config: state => state.config,
        }),
      },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-consents {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-consents__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-consents__title {
            font-family: "Oswald", sans-serif;
            font-size: 25px;
            line-height: 1;
            display: inline-block;
            text-transform: uppercase;
        }

        .cc-consents__main {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }
    }
</style>
